import axios from 'axios';
import { apiUrl } from '../../../shared/links';

export const excelBoreholeService = (token: string) => {
  const exportExcelUrl = `${apiUrl}/borehole/Excel`;
  try {
    return axios.get(exportExcelUrl, {
      headers: {
        'Authorization': `Bearer ${token}`
      },
      responseType: 'blob'
    }).then((response) => {
      return new Blob([response.data]);
    });
  } catch (ex) {
    if (!ex.response || !ex.response.data) {
      console.log(ex);
    }
    console.log(ex.response.data);
  }
};
